<template>
  <div>
    <sidenav
      :is-sidebar-active.sync="isSidebarActive"
      :item-edit="itemEdit"
      :device-tag-options="deviceTagOptions"
      :reseller-options="resellerOptions"
      @refetch-data="refetchData"
    />

    <b-row class="pt-2 pb-1">
      <b-col cols="12" class="d-flex align-items-center">
        <BreadcrumbMenu />
      </b-col>
    </b-row>

    <b-card-group deck class="mx-2">
      <b-card class="m-0" no-body>
        <div class="m-2">
          <b-row>
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('table.search') + '...'"
                />
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refListTable"
          class="position-relative"
          :items="fetchList"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          :empty-text="$t('no_record_found')"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #head()="data">
            <span>{{ $tc(data.label, 1) }}</span>
          </template>

          <template #cell(active)="data">
            <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'">
              {{ data.item.active ? "Sí" : "No" }}
            </b-badge>
          </template>

          <template #cell(assigned_user)="data">
            {{ data.item.assigned_user ? data.item.assigned_user.name : "-" }}
          </template>

          <template #cell(system_controller)="data">
            {{ data.item.system_controller ? data.item.system_controller.name || data.item.system_controller.serial_number : "-" }}
          </template>

          <template #cell(proxy_rtsp_server_name)="data">
            {{ data.item.proxy_rtsp_server_name || "-" }}
          </template>

          <template #cell(device_tag_name)="data">
            {{ data.item.device_tag_name || "-" }}
          </template>

          <template #cell(omniview_reseller_name)="data">
            {{ data.item.omniview_reseller_name || "-" }}
          </template>

          <template #cell(units)="data">
            {{ data.item.units && data.item.units.length ? data.item.units.map((u) => u.description).join(", ") : "-" }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                  data-cy="actions"
                />
              </template>

              <b-dropdown-item @click="openEdit(data.item)" data-cy="edit-btn">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{ $t("actions.edit") }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted text-capitalize">{{
                $t("table.showing", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of })
              }}</span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <Pagination :totalList="totalList" :currentPage="currentPage" @updatePagination="update" :perPage="perPage" />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BFormInput, BTable, BBadge, BDropdown, BDropdownItem } from "bootstrap-vue";
import vSelect from "vue-select";
import useList from "./useList";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import Sidenav from "./Sidenav.vue";

export default {
  components: {
    BreadcrumbMenu,
    Pagination,
    Sidenav,
    BDropdown,
    BDropdownItem,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    vSelect,
  },
  setup() {
    return {
      ...useList(),
    };
  },
};
</script>
